import React, { useState, useEffect, useRef } from 'react';
import { Map, GoogleApiWrapper, Marker, InfoWindow } from 'google-maps-react';
import axios from 'axios';
import { observer } from 'mobx-react-lite';
import { mapStyles } from './components/MapStyles';

const API_KEY = 'AIzaSyDCcG5SUAVR66ZIbPbTKkEp1FZoZ6wHBjk';

const GoogleMaps = props => {
  const { scale, address, mapStyle = null, pinTitle, pinDescription } = props.settings;
  const [coords, setCoords] = useState(null);
  const [formatedAddress, setFormatedAddress] = useState('');

  const [selectedPlace, setSelectedPlace] = useState();
  const [activeMarker, setActiveMarker] = useState({});
  const [showingInfoWindow, setshowingInfoWindow] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (address.length > 0) {
      getCoordinatesByAdress(address);
    }
  }, [address]);

  useEffect(() => {
    if (wrapRef.current && wrapRef.current.parentElement && !wrapRef.current.parentElement.classList.contains('maps-outer-wrap')) {
      wrapRef.current.parentElement.classList.add('maps-outer-wrap');
    }
  }, [wrapRef?.current]);

  const getCoordinatesByAdress = address => {
    const convertedAddress = (address = address.replace(/[åä]/g, 'a').replace(/ö/g, 'o').replace(/\s/g, '+'));
    axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${convertedAddress}&key=${API_KEY}`).then(res => {
      const location = res.data?.results?.[0]?.geometry?.location;
      const formatedAddress = res.data?.results[0]?.formatted_address;
      setCoords(location);
      setFormatedAddress(formatedAddress);
    });
  };

  const onMarkerClick = (props, marker, e) => {
    setSelectedPlace(props);
    setActiveMarker(marker);
    setshowingInfoWindow(true);
  };

  if (!address.length > 0 || !coords) {
    return (
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <img src={window.location.origin + '/icons/google_maps.svg'} width={'200px'} />
      </div>
    );
  }
  return (
    <div ref={r => (wrapRef.current = r)} className="maps-inner-wrap">
      <Map
        google={props.google}
        zoom={scale}
        disableDefaultUI={true}
        center={coords}
        initialCenter={coords}
        onReady={(mapProps, map) => {
          if (mapStyle) {
            map.setOptions({
              styles: mapStyles[mapStyle],
            });
          }
        }}
      >
        <Marker position={coords} name={formatedAddress} title={formatedAddress} onClick={onMarkerClick} />
        <InfoWindow marker={activeMarker} visible={showingInfoWindow}>
          <div>
            {pinTitle ? <h2>{pinTitle}</h2> : null}
            <h5>{formatedAddress}</h5>
            {pinDescription ? <p>{pinDescription}</p> : null}
          </div>
        </InfoWindow>
      </Map>
    </div>
  );
};

export default GoogleApiWrapper({
  apiKey: API_KEY,
})(observer(GoogleMaps));
